import { t } from "ttag";

import { Header } from "@/shared/ui";

export const CoachingHubHeader = () => {
  return (
    <Header.Root>
      <Header.Content className="flex-row items-center justify-between">
        <Header.Title>{t`Coaching hub`}</Header.Title>

        {/* <BookOneOnOneDropdownMenu position="header" /> */}
      </Header.Content>
    </Header.Root>
  );
};
